import React, { useContext } from 'react'

interface IOfferCestovkoContext {
  onCompareClick: Function
}

interface IOfferCestovkoProvider {
  onCompareClick: Function
  children?: React.ReactNode
}

const defaultState = {
  onCompareClick: () => { }
}

const OfferCestovkoContext = React.createContext<IOfferCestovkoContext>(defaultState)

export const OfferCestovkoProvider = ({ onCompareClick, children }: IOfferCestovkoProvider) => {
  return (
    <OfferCestovkoContext.Provider
      value={{
        onCompareClick,
      }}
    >
      {children && children}
    </OfferCestovkoContext.Provider>
  )
}

export const useOfferCestovko = () => {
  const context = useContext(OfferCestovkoContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOfferCestovko must be used within a OfferCestovkoProvider!')
  }

  return context
}
